import styled from "styled-components";

export default styled.div.attrs({
  className: "f6"
})`
  color: #e7040f;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
`;



// WEBPACK FOOTER //
// ./src/components/generic/form/service/Error/index.js